import React from 'react';
import { motion } from 'framer-motion';
import { textVariants, containerVariants, corporateContainerVariants } from '../../script/animationVariants'; // Animasyon varyantlarını içe aktarıyoruz

const TeknikBilgilerVeMakaleler = () => {
  // Verileri bir dizi içerisinde tutuyoruz
  const makalelerData = [
    {
      title: 'Lorem ipsum dolor sit amet,',
      content: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod 
                tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis 
                nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. 
                Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel 
                illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui 
                blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.`,
    },
    {
      title: 'Lorem ipsum dolor sit amet,',
      content: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod 
                tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis 
                nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. 
                Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel 
                illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui 
                blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.`,
    },
    {
      title: 'Lorem ipsum dolor sit amet,',
      content: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod 
                tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis 
                nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. 
                Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel 
                illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui 
                blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.`,
    },
    {
      title: 'Lorem ipsum dolor sit amet,',
      content: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod 
                tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis 
                nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. 
                Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel 
                illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui 
                blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.`,
    },
  ];

  return (
    <
    >
      {makalelerData.map((makale, index) => (
        <motion.div 
          key={index} 
          className='text-20 font-light mb-20'
          variants={corporateContainerVariants}
        >
          <motion.h1 className='text-33 mb-4' variants={textVariants}>
            {makale.title}
          </motion.h1>
          <motion.p variants={textVariants}>{makale.content}</motion.p>
          <motion.p variants={textVariants}>{makale.content}</motion.p>
          <motion.div 
            className='py-2 px-8 border-customGray border inline-block mt-5' 
            variants={textVariants}
          >
            Detaylar için
          </motion.div>
        </motion.div>
      ))}
    </>
  );
}

export default TeknikBilgilerVeMakaleler;
